import {connect} from "react-redux";
import {mapDispatchToProps} from "../store/helpers/mapDispatch";
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Typography
} from "@mui/material";
import * as React from "react";
import {successToast} from "./Notification";
import {getError, getSuccessMessage} from "../store/helpers/common_functions";
import {useEffect} from "react";


function RequestDialog({open,setOpen,FetchDetails,url,info,title,maxWidth,render}){

    const [requesting,setRequesting] = React.useState(false);
    const [error,setError] = React.useState();
    const [data,setData] = React.useState();

    const handleClose = ()=>{
        setError(null);
        setOpen(false);
    }

    const loadData = async ()=>{
        setRequesting(true);
        const resp = await FetchDetails(url);
        if(resp.status){
            setData(resp.data);
        }else{
            setError(getError(resp));
        }
        setRequesting(false);
    }


    useEffect(()=>{
        if(url && open){
            loadData().then();
        }
    },[url]);

    return <Dialog open={open} fullWidth={true} maxWidth={maxWidth??'xs'} onClose={handleClose}>
        {requesting ? (
            <div
                className={
                    "absolute h-full w-full top-0 left-0 flex z-50 justify-center items-center"
                }
                style={{backgroundColor: "rgba(83,220,85,0.2)" }}
            >
                <div
                    className={"bg-white p-3 rounded shadow text-center"}
                    style={{ zIndex: 20000 }}
                >
                    <div>
                        <CircularProgress color={'success'} />
                    </div>
                    <span>
              <Typography color={'success'}>{'Fetching details'} ....</Typography>
            </span>
                </div>
            </div>
        ) : null}
        <DialogTitle>{title ?? 'Details'}</DialogTitle>
        <DialogContent>
            {error ? (
                <Alert
                    style={{ width: "100%" }}
                    className={"mb-3"}
                    severity={"error"}
                    onClose={()=>setError(null)}
                >
                    {error}
                </Alert>
            ) : null}
            <div>
                {typeof render === 'function' && render(data)}
            </div>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Close</Button>
        </DialogActions>
    </Dialog>
}

export default connect(null,mapDispatchToProps)(RequestDialog);
